/**
 * 口播文本清洗(1007)—— ai 侧口播清洗的 TS 镜像,截断预告必须**先清洗再截断**。
 *
 * 1007 测试机实证:用户把口播写成带中文引号、分行的一段(`“……？”\n“……”`),
 * ai 侧烧录字幕会出孤立的「”」、换行处的句子没有字幕。ai 侧同批新增清洗,截断按清洗后的字数算;
 * console 的截断预告(voiceoverCap)必须用同一口径,否则提示「当前 91 字」而服务端按 83 字截,
 * 预告的裁点会和成片对不上。
 *
 * 规则(与 ai 侧逐条对齐,改一边必须改另一边):
 *   ① 去掉引号:“ ” ‘ ’ 「 」 『 』 以及半角 " '
 *   ② 换行 / 回车 / 制表(连续的算一处,连同两侧空白)折成句读:
 *      前面(已输出部分去掉尾部空白后)以标点结尾或为空 → 直接去掉;否则补一个「，」
 *   ③ 连续空白(半角空格 / 全角空格)压成一个半角空格,首尾去空白
 *   ④ (1013 V2)去掉开头的转述前导语(「这个视频的口播内容一字不差提炼如下：」):开头到第一个
 *      冒号 ≤40 字、不含 。！？!?,且含稿件元词(口播/文案/台词/脚本/讲稿/旁白/逐字稿/配音稿)
 *      或「如下/以下」+「视频/内容」;冒号后还有正文才去,反复去到不再命中
 */

const QUOTES_RE = /[“”‘’「」『』"']/g;

// 行尾「已有句读」判定集:小句边界集(voiceoverCap 同款)+ 冒号 / 省略号 / 破折号。
const LINE_END_PUNCT = "。！？；，、.!?;,：:…—";

const LINE_BREAK_RUN_RE = /[ \u3000]*[\r\n\t]+[ \u3000\r\n\t]*/g;

const PREAMBLE_RE = /^([^。！？!?：:]{1,40})[：:][ \u3000]*/;
const PREAMBLE_META = ["口播", "文案", "台词", "脚本", "讲稿", "旁白", "逐字稿", "配音稿"];
const PREAMBLE_LEAD = ["如下", "以下"];
const PREAMBLE_SUBJ = ["视频", "内容"];

function isPreamble(head: string): boolean {
  if (PREAMBLE_META.some((w) => head.includes(w))) return true;
  return PREAMBLE_LEAD.some((w) => head.includes(w)) && PREAMBLE_SUBJ.some((w) => head.includes(w));
}

export function stripVoiceoverPreamble(text: string): string {
  let t = text;
  for (;;) {
    const m = PREAMBLE_RE.exec(t);
    if (!m || !isPreamble(m[1]) || !t.slice(m[0].length).trim()) return t;
    t = t.slice(m[0].length);
  }
}

export function sanitizeVoiceover(voiceover: string | null | undefined): string {
  const noQuotes = (voiceover ?? "").replace(QUOTES_RE, "");
  let out = "";
  let last = 0;
  for (const m of noQuotes.matchAll(LINE_BREAK_RUN_RE)) {
    const idx = m.index ?? 0;
    out += noQuotes.slice(last, idx);
    out = out.replace(/[ \u3000]+$/, "");
    const atEnd = idx + m[0].length >= noQuotes.length;
    if (out.length > 0 && !atEnd && !LINE_END_PUNCT.includes(out[out.length - 1])) out += "，";
    last = idx + m[0].length;
  }
  out += noQuotes.slice(last);
  return stripVoiceoverPreamble(out.replace(/[ \u3000]+/g, " ").trim()).trim();
}
